import React from 'react';
import { BsTwitter, BsInstagram , BsLinkedin ,BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
    <a href="https://www.linkedin.com/in/zeeshannawaz95/" target="_blank">
    <BsLinkedin />
  </a>
    </div>
    <div>
    <a href="https://github.com/xee95" target="_blank">
    <BsGithub/>
  </a>
    </div>
    
  </div>
);

export default SocialMedia;
